import { useEffect, useState } from "react";
import { useScreenWidth } from "../SubscriptionPageV2/hooks";
import { useDispatch } from "react-redux";
import * as api from "Root/api/apiProfile";
import { useHistory, useParams } from "react-router-dom";
import { setGlobalLoading } from "Root/profile/redux/actionCreators/makeActionCreator";
import toastService from "Root/profile/toastService";
import posthog from "posthog-js";
const useMemberPerkPage = () => {
    const { perkId } = useParams();
    const [openDrawer, setOpenDrawer] = useState(false);
    const [openNutritionFactsDrawer, setOpenNutritionFactsDrawer] = useState(false);
    const [selectedFlavor, setSelectedFlavor] = useState([]);
    const [memberPerk, setMemberPerk] = useState(null);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const dispatch = useDispatch();
    const history = useHistory();
    const toggleDrawer = (value) => () => {
        setOpenDrawer(value);
    };
    const toggleNutritionFactsDrawer = (value) => () => {
        setOpenNutritionFactsDrawer(value);
    };
    const onChangeFlavor = (count, short_name) => {
        const flavors = selectedFlavor.map((item) => {
            if (item.short_name === short_name) {
                return {
                    count,
                    short_name,
                    full_name: item.full_name,
                };
            }
            return {
                count: 0,
                short_name: item.short_name,
                full_name: item.full_name,
            };
        });
        setSelectedFlavor(flavors);
    };
    const isMobile = useScreenWidth() < 1080;
    const fetchData = async () => {
        try {
            dispatch(setGlobalLoading(true));
            const data = await api.getMemberPerks(perkId);
            setMemberPerk({
                ...data,
                dates: {
                    ...data.dates,
                    month: Number(data.dates.month) - 1,
                    minDate: convertStringToDate(data.bill_start_date),
                    maxDate: convertStringToDate(data.bill_end_date),
                },
            });
            setSelectedFlavor(data.product.available_flavors.map((item, index) => ({
                count: data.product.available_flavors.length > 1 && index > 0 ? 0 : 1,
                short_name: item.short_name,
                full_name: item.full_name,
            })));
            dispatch(setGlobalLoading(false));
        }
        catch (e) {
            toastService.errorMessage("Could not fetch promotion.");
            dispatch(setGlobalLoading(false));
        }
    };
    const submit = async () => {
        try {
            dispatch(setGlobalLoading(true));
            let { sku } = memberPerk.product;
            if (memberPerk.product.available_flavors.length > 0) {
                const flavor = selectedFlavor.find((item) => item.count)?.short_name;
                sku = memberPerk.product.available_flavors.find((item) => item.short_name === flavor)?.sku;
            }
            toggleDrawer(false)();
            await api.postMemberPerks({
                bill_date: `${selectedDate.getFullYear()}-${selectedDate.getMonth() + 1}-${selectedDate.getDate()}`,
                sku,
                page_id: perkId,
            });
            posthog.capture("memberperk_add_to_box");
            posthog.capture("member_perk_confirm_date");
            dispatch(setGlobalLoading(false));
            history.push(`/app/thank-you?from=memberperk&sku=${sku}`);
        }
        catch (e) {
            toastService.handleError(e);
            dispatch(setGlobalLoading(false));
        }
    };
    const addPromoForOneTime = async () => {
        dispatch(setGlobalLoading(true));
        await api.memberPerkPromo({
            perk_id: perkId,
        });
        posthog.capture("memberperk_one_time");
        dispatch(setGlobalLoading(false));
    };
    const formatDate = (date) => {
        // format date from yyyy-mm-dd to mm/dd
        const dateArr = date.split("-");
        return `${dateArr[1]}/${dateArr[2]}`;
    };
    const convertStringToDate = (date) => {
        const dateArr = date.split("-");
        return new Date(Number(dateArr[0]), Number(dateArr[1]) - 1, Number(dateArr[2]));
    };
    const getProductImage = () => {
        if (memberPerk.member_perk_image) {
            return memberPerk.member_perk_image;
        }
        const flavor = selectedFlavor.find((item) => item.count)?.short_name;
        if (flavor && flavor !== "variety") {
            return memberPerk?.product.available_flavors.find((item) => item.short_name === flavor)?.thumbnail_img_url;
        }
        return memberPerk.img_url;
    };
    const changeBillDate = () => {
        posthog.capture("memberperk_change_bill_date");
        toggleDrawer(true)();
    };
    useEffect(() => {
        fetchData();
        posthog.capture("$pageview");
    }, []);
    return {
        openDrawer,
        toggleDrawer,
        openNutritionFactsDrawer,
        toggleNutritionFactsDrawer,
        isLoading: memberPerk === undefined,
        data: memberPerk,
        memberPerk,
        isMobile,
        selectedFlavor,
        setSelectedFlavor,
        onChangeFlavor,
        formatDate,
        submit,
        selectedDate,
        setSelectedDate,
        getProductImage,
        changeBillDate,
        addPromoForOneTime,
    };
};
export default useMemberPerkPage;
